import { concat, map, prop, none } from 'ramda';

const PROTECTED_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  mixins: true,
  propTypes: true,
  type: true,
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

const {
  defineProperty,
  getOwnPropertyNames,
  getOwnPropertySymbols,
  getOwnPropertyDescriptor,
  getPrototypeOf
} = Object;

const objectPrototype = getPrototypeOf && getPrototypeOf(Object);

export default function safelyHoistStatics(
  targetComponent,
  sourceComponent,
  blacklist = {}
) {
  if (typeof sourceComponent !== 'string') {
    if (objectPrototype) {
      const inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        safelyHoistStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    let keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = concat(getOwnPropertySymbols(sourceComponent), keys);
    }

    map((key) => {
      if (none((list) => prop(key, list), [PROTECTED_STATICS, blacklist])) {
        try {
          // Handle read-only properties gracefully
          defineProperty(
            targetComponent,
            key,
            getOwnPropertyDescriptor(sourceComponent, key)
          );
        } catch (e) {
          // Noop
        }
      }
    }, keys);
  }

  return targetComponent;
}
